import React from "react";
import ReactDOM from "react-dom";
import { Spinner, Row, Col, Progress } from "reactstrap";
import axios from "axios";
import "../App.css";

const Loading = React.memo(props => {
  const { progress, determinate } = props;
  const progressAnimation = determinate ? (
    <Progress
      style={{ width: "50vw" }}
      animated
      barClassName="bg-black"
      value={progress}
    >
      {progress}%
    </Progress>
  ) : (
    <Spinner
      style={{
        width: "5vw",
        height: "5vw"
      }}
      color="dark"
      className="loading-spinner"
    />
  );
  return (
    <div>
      <Col style={{ position: "relative", top: "25vh" }}>
        <Row className="d-flex justify-content-center" sm={12}>
          {progressAnimation}
        </Row>
        <Row className="d-flex justify-content-center">
          <h1>{props.message ? props.message.trim() : "Loading"}</h1>
        </Row>
      </Col>
    </div>
  );
});

export default Loading;



// WEBPACK FOOTER //
// ./src/views/loading.jsx